import { useMutation, useQuery } from '@tanstack/react-query'
import { instance } from '../instance'
export const useFetchPermissions = (filters?: Filters) => {
  const fetchAllPermissions = async (): Promise<FetchPermissionResponse> => {
    const response = await instance.get(
      `/admin-dashboard/permission?searchTerm=${
        filters?.searchTerm
      }&pageNumber=${filters?.pageNumber}&pageSize=${filters?.pageSize || 10}`,
    )
    return response.data
  }
  const queryApi = useQuery({
    queryKey: ['fetch all permissions', filters],
    queryFn: fetchAllPermissions,
  })
  return queryApi
}
export const useCreatePermission = () => {
  const createNewPermission = async (payload: {
    name: string
  }): Promise<CreatePermissionResponse> => {
    const response = await instance.post(`/admin-dashboard/permission`, payload)
    return response.data
  }
  const mutateAPI = useMutation({
    mutationKey: ['Create new permission'],
    mutationFn: (payload: { name: string }) => createNewPermission(payload),
  })
  return mutateAPI
}
